import React, { useContext, useState, } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const CustomerContext = React.createContext();


export const CustomerProvider = ({ children }) => {

    const { btoken, } = useUserContext();

    let data = { btoken, };

    const {
        loading: customerLoading, data: allCustomers, fetchData: getCustomerData
    } = useFetch('/getCustomers', data);


    return (
        <CustomerContext.Provider value={{

            customerLoading, allCustomers, getCustomerData,
        }}>
            {children}
        </CustomerContext.Provider>
    );
};

// make sure use
export const useCustomerContext = () => {
    return useContext(CustomerContext);
};
